import React, {useContext} from 'react'
import {RecipeConText} from "../../../../../context/RecipeContext";

const RecipeItemCurrency = ({rowId}) => {

    const {rowData} = useContext(RecipeConText)
    const [rowState] = rowData

    return(
        <React.Fragment>
            {
                rowState[rowId].data ? rowState[rowId].data.currency : null
            }
        </React.Fragment>
    )
}
export default RecipeItemCurrency